/**
 * This file was generated by kysely-codegen.
 * Please do not edit it manually.
 */

import type { ColumnType } from "kysely";

export enum AccountRequestStatus {
  APPROVED = "approved",
  CANCELED = "canceled",
  CREATED = "created",
  PENDING = "pending",
  REJECTED = "rejected",
}

export enum CommissionEarningStatus {
  AVAILABLE = "available",
  PAID = "paid",
  POOLED = "pooled",
  POOLED_DISTRIBUTED = "pooled_distributed",
  POOLED_REDIRECTED = "pooled_redirected",
}

export enum CommissionPayoutProvider {
  PAYPAL_DUMMY = "paypal_dummy",
}

export enum CommissionRateType {
  FOUNDER_BY_CUSTOMER_PURCHASE = "founder_by_customer_purchase",
  FOUNDER_BY_VENDOR_SALE = "founder_by_vendor_sale",
  INFLUENCER_BY_CUSTOMER_PURCHASE = "influencer_by_customer_purchase",
  SPARK_BY_CUSTOMER_PURCHASE = "spark_by_customer_purchase",
  SPARK_BY_VENDOR_SALE = "spark_by_vendor_sale",
}

export enum CommissionWithdrawalStatus {
  COMPLETED = "completed",
  FAILED = "failed",
}

export enum FounderCommissionCutoffStatus {
  EXECUTED = "executed",
}

export enum FounderCommissionDistributionStatus {
  CREDITED = "credited",
}

export enum FreedomFundCutoffStatusType {
  EXECUTED = "executed",
  PENDING = "pending",
}

export enum FreedomFundDistributionStatusType {
  ACCEPTED = "accepted",
  IGNORED = "ignored",
  PENDING = "pending",
  REJECTED = "rejected",
}

export enum Gender {
  FEMALE = "female",
  MALE = "male",
  OTHER = "other",
}

export enum ImageableType {
  ACCOUNT_REQUESTS = "account_requests",
  USERS = "users",
}

export enum InvitationCampaignStatus {
  CANCELED = "canceled",
  DRAFT = "draft",
  FAILED = "failed",
  QUEUED = "queued",
  SENDING = "sending",
  SENT = "sent",
}

export enum InvitationContactStatus {
  BOUNCED = "bounced",
  COMPLAINED = "complained",
  CONVERTED = "converted",
  INVITED = "invited",
  PENDING = "pending",
  REQUESTED = "requested",
  UNSUBSCRIBED = "unsubscribed",
}

export enum InvitationEmailEventType {
  ACCEPTED = "accepted",
  BOUNCED = "bounced",
  CLICKED = "clicked",
  COMPLAINED = "complained",
  DELIVERED = "delivered",
  FAILED = "failed",
  OPENED = "opened",
  UNSUBSCRIBED = "unsubscribed",
}

export enum InvitationRecipientStatus {
  BOUNCED = "bounced",
  CLICKED = "clicked",
  COMPLAINED = "complained",
  DELIVERED = "delivered",
  FAILED = "failed",
  OPENED = "opened",
  PENDING = "pending",
  QUEUED = "queued",
  SENT = "sent",
  UNSUBSCRIBED = "unsubscribed",
}

export enum PaymentStatusType {
  CANCELLED = "cancelled",
  COMPLETED = "completed",
  FAILED = "failed",
  PENDING = "pending",
}

export enum Privacy {
  PRIVATE = "private",
  PUBLIC = "public",
}

export enum SystemStage {
  ALPHA = "alpha",
  BETA = "beta",
  INITIAL = "initial",
  PILOT = "pilot",
}

export enum UserStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum UserType {
  CUSTOMER = "customer",
  FOUNDER = "founder",
  INFLUENCER = "influencer",
  SPARK = "spark",
  VENDOR = "vendor",
}

export type Generated<T> = T extends ColumnType<infer S, infer I, infer U>
  ? ColumnType<S, I | undefined, U>
  : ColumnType<T, T | undefined, T>;

export type Int8 = ColumnType<string, bigint | number | string, bigint | number | string>;

export type Json = JsonValue;

export type JsonArray = JsonValue[];

export type JsonObject = {
  [x: string]: JsonValue | undefined;
};

export type JsonPrimitive = boolean | number | string | null;

export type JsonValue = JsonArray | JsonObject | JsonPrimitive;

export type Timestamp = ColumnType<Date, Date | string, Date | string>;

export interface AccountRequests {
  account_type: UserType;
  approved_by_user_id: string | null;
  birthdate: Timestamp | null;
  cellphone: string;
  cellphone_country_code: string;
  confirmed_cellphone: Generated<boolean | null>;
  confirmed_email: Generated<boolean | null>;
  created_at: Generated<Timestamp>;
  currency: Generated<string>;
  day_privacy: Generated<Privacy | null>;
  email: string;
  first_name: string;
  gender: Gender | null;
  gender_other: string | null;
  gender_privacy: Generated<Privacy | null>;
  id: Generated<string>;
  introduction: string | null;
  last_name: string;
  location: Json | null;
  location_privacy: Generated<Privacy | null>;
  month_privacy: Generated<Privacy | null>;
  photo_url: string | null;
  questionary: Json | null;
  referral_key: string | null;
  referred_by_user_id: string | null;
  status: Generated<AccountRequestStatus>;
  updated_at: Generated<Timestamp>;
  year_privacy: Generated<Privacy | null>;
}

export interface AccountRequestsApprovalsControl {
  created_at: Generated<Timestamp | null>;
  id: Generated<string>;
  remaining_approvals: Generated<number | null>;
  stage: SystemStage;
  updated_at: Generated<Timestamp | null>;
  user_id: string;
  user_type: UserType;
}

export interface AccountRequestsStatusLog {
  account_request_id: string | null;
  changed_at: Generated<Timestamp>;
  changed_by_user_id: string | null;
  new_status: AccountRequestStatus;
  old_status: AccountRequestStatus;
}

export interface Accounts {
  access_token: string | null;
  access_token_expires_at: Timestamp | null;
  account_id: string;
  created_at: Generated<Timestamp | null>;
  id: string;
  id_token: string | null;
  password: string | null;
  provider_id: string;
  refresh_token: string | null;
  refresh_token_expires_at: Timestamp | null;
  scope: string | null;
  updated_at: Generated<Timestamp | null>;
  user_id: string;
}

export interface CommissionBackfillRuns {
  completed_at: Generated<Timestamp>;
  name: string;
}

export interface CommissionBalances {
  available_amount: Generated<number>;
  currency: string;
  total_earned: Generated<number>;
  updated_at: Generated<Timestamp>;
  user_id: string;
  withdrawn_amount: Generated<number>;
}

export interface CommissionEarnings {
  base_transaction_amount: number;
  beneficiary_user_id: string | null;
  chain_founder_user_id: string | null;
  chain_level: number;
  commission_amount: number;
  created_at: Generated<Timestamp>;
  currency: Generated<string>;
  founder_commission_cutoff_id: string | null;
  id: Generated<string>;
  metadata: Json | null;
  percentage: number;
  rate_type: CommissionRateType;
  reference_id: string;
  source_user_id: string | null;
  status: CommissionEarningStatus;
  transfer_id: string | null;
}

export interface CommissionFounderPool {
  balance: Generated<number>;
  currency: Generated<string>;
  id: Generated<number>;
  updated_at: Generated<Timestamp>;
}

export interface CommissionPayoutMethods {
  account_identifier: string;
  auto_withdraw_enabled: Generated<boolean>;
  created_at: Generated<Timestamp>;
  id: Generated<string>;
  provider: CommissionPayoutProvider;
  updated_at: Generated<Timestamp>;
  user_id: string;
}

export interface CommissionReceipts {
  amount: number;
  created_at: Generated<Timestamp>;
  currency: string;
  founder_commission_cutoff_id: string | null;
  id: Generated<string>;
  rate_type: CommissionRateType | null;
  reference_id: string | null;
  source_commission_earning_id: string | null;
  source_user_id: string | null;
  type: string;
  user_id: string;
}

export interface CommissionWithdrawals {
  amount: number;
  currency: string;
  id: Generated<string>;
  is_auto: Generated<boolean>;
  payout_method_id: string;
  processed_at: Timestamp | null;
  requested_at: Generated<Timestamp>;
  status: Generated<CommissionWithdrawalStatus>;
  user_id: string;
}

export interface FounderCommissionCutoff {
  amount_by_founder: number;
  created_at: Generated<Timestamp>;
  cutoff_date: Generated<Timestamp>;
  distributable_amount: number;
  id: Generated<string>;
  redirected_to_freedom_fund: Generated<boolean>;
  status: Generated<FounderCommissionCutoffStatus>;
  total_founders: number;
}

export interface FounderCommissionDistribution {
  created_at: Generated<Timestamp>;
  founder_commission_cutoff_id: string | null;
  id: Generated<string>;
  status: Generated<FounderCommissionDistributionStatus>;
  user_id: string | null;
  withdrawable_amount: number;
}

export interface FreedomFundCutoff {
  amount_by_user: number;
  created_at: Generated<Timestamp | null>;
  cutoff_date: Generated<Timestamp>;
  distributable_amount: number;
  id: Generated<string>;
  status: Generated<FreedomFundCutoffStatusType>;
  total_users: number;
}

export interface FreedomFundDistribution {
  created_at: Generated<Timestamp | null>;
  freedom_fund_cutoff_id: string | null;
  id: Generated<string>;
  status: Generated<FreedomFundDistributionStatusType>;
  status_change_at: Timestamp | null;
  user_id: string | null;
  withdrawable_amount: number;
}

export interface InvitationCampaignRecipients {
  bounced_at: Timestamp | null;
  campaign_id: string;
  click_count: Generated<number>;
  complained_at: Timestamp | null;
  contact_id: string | null;
  created_at: Generated<Timestamp | null>;
  delivered_at: Timestamp | null;
  email: string;
  error: string | null;
  failed_at: Timestamp | null;
  first_clicked_at: Timestamp | null;
  first_name: string | null;
  first_opened_at: Timestamp | null;
  id: Generated<string>;
  last_clicked_at: Timestamp | null;
  last_name: string | null;
  last_opened_at: Timestamp | null;
  open_count: Generated<number>;
  provider: string | null;
  provider_message_id: string | null;
  queued_at: Timestamp | null;
  referral_key_id: string | null;
  sent_at: Timestamp | null;
  status: Generated<InvitationRecipientStatus>;
  subject: string | null;
  unsubscribed_at: Timestamp | null;
  updated_at: Generated<Timestamp | null>;
}

export interface InvitationCampaigns {
  account_type: Generated<UserType>;
  body: string;
  created_at: Generated<Timestamp | null>;
  error: string | null;
  id: Generated<string>;
  name: string;
  sent_at: Timestamp | null;
  status: Generated<InvitationCampaignStatus>;
  subject: string;
  template_id: string | null;
  total_recipients: Generated<number>;
  updated_at: Generated<Timestamp | null>;
  user_id: string;
}

export interface InvitationContacts {
  account_request_id: string | null;
  address: string | null;
  cellphone: string | null;
  cellphone_country_code: string | null;
  city: string | null;
  country: string | null;
  created_at: Generated<Timestamp | null>;
  email: string;
  first_name: string;
  id: Generated<string>;
  last_name: string | null;
  notes: string | null;
  postal_code: string | null;
  state: string | null;
  status: Generated<InvitationContactStatus>;
  unsubscribed_at: Timestamp | null;
  updated_at: Generated<Timestamp | null>;
  user_id: string;
}

export interface InvitationEmailEvents {
  campaign_id: string | null;
  client_name: string | null;
  country: string | null;
  created_at: Generated<Timestamp | null>;
  device_type: string | null;
  event: InvitationEmailEventType;
  id: Generated<string>;
  ip: string | null;
  occurred_at: Generated<Timestamp>;
  provider: Generated<string>;
  provider_event_id: string | null;
  provider_message_id: string | null;
  raw: Json | null;
  reason: string | null;
  recipient_email: string | null;
  recipient_id: string | null;
  url: string | null;
  user_agent: string | null;
}

export interface InvitationTemplates {
  account_type: Generated<UserType>;
  body: string;
  created_at: Generated<Timestamp | null>;
  description: string | null;
  id: Generated<string>;
  name: string;
  subject: string;
  updated_at: Generated<Timestamp | null>;
  user_id: string;
}

export interface Notifications {
  created_at: Generated<Timestamp | null>;
  error: string | null;
  id: Generated<string>;
  provider: string;
  status: string;
  subject: string;
  template: string;
  to: string;
  type: string;
  updated_at: Generated<Timestamp | null>;
}

export interface Payments {
  amount: number;
  charge_amount: number;
  charge_currency: string;
  created_at: Generated<Timestamp | null>;
  description: string | null;
  id: Generated<string>;
  key: string;
  meta: Json | null;
  order_id: string;
  status: Generated<PaymentStatusType>;
  updated_at: Generated<Timestamp | null>;
  user_id: string | null;
}

export interface PaymentTransfers {
  created_at: Generated<Timestamp | null>;
  id: Generated<string>;
  payment_id: string;
  transfer_id: string;
}

export interface PgledgerAccounts {
  allow_negative_balance: boolean;
  allow_positive_balance: boolean;
  balance: Generated<number>;
  created_at: Timestamp;
  currency: string;
  id: Generated<string>;
  metadata: Json | null;
  name: string;
  updated_at: Timestamp;
  version: Generated<Int8>;
}

export interface PgledgerAccountsView {
  allow_negative_balance: boolean | null;
  allow_positive_balance: boolean | null;
  balance: number | null;
  created_at: Timestamp | null;
  currency: string | null;
  id: string | null;
  metadata: Json | null;
  name: string | null;
  updated_at: Timestamp | null;
  version: Int8 | null;
}

export interface PgledgerEntries {
  account_current_balance: number;
  account_id: string;
  account_previous_balance: number;
  account_version: Int8;
  amount: number;
  created_at: Timestamp;
  id: Generated<string>;
  transfer_id: string;
}

export interface PgledgerEntriesView {
  account_current_balance: number | null;
  account_id: string | null;
  account_previous_balance: number | null;
  account_version: Int8 | null;
  amount: number | null;
  created_at: Timestamp | null;
  description: string | null;
  event_at: Timestamp | null;
  id: string | null;
  metadata: Json | null;
  transfer_id: string | null;
}

export interface PgledgerTransfers {
  amount: number;
  created_at: Timestamp;
  description: string | null;
  event_at: Timestamp;
  from_account_id: string;
  id: Generated<string>;
  metadata: Json | null;
  to_account_id: string;
}

export interface PgledgerTransfersView {
  amount: number | null;
  created_at: Timestamp | null;
  description: string | null;
  event_at: Timestamp | null;
  from_account_id: string | null;
  id: string | null;
  metadata: Json | null;
  to_account_id: string | null;
}

export interface Pictures {
  created_at: Generated<Timestamp | null>;
  id: Generated<string>;
  image_url: string;
  target: ImageableType;
  target_id: string;
  updated_at: Generated<Timestamp | null>;
}

export interface ReferralKeys {
  account_type: Generated<UserType>;
  campaign_id: string | null;
  clicks: Generated<number | null>;
  conversions: Generated<number | null>;
  created_at: Generated<Timestamp | null>;
  disabled: Generated<boolean>;
  id: Generated<string>;
  key: string;
  name: string;
  updated_at: Generated<Timestamp | null>;
  user_id: string;
}

export interface RefreshTokens {
  created_at: Generated<Timestamp | null>;
  expires_at: Timestamp;
  id: Generated<string>;
  token: string;
  user_id: string;
}

export interface Sessions {
  created_at: Generated<Timestamp | null>;
  expires_at: Timestamp;
  id: string;
  ip_address: string | null;
  token: string;
  updated_at: Generated<Timestamp | null>;
  user_agent: string | null;
  user_id: string;
}

export interface Users {
  account_request_id: string | null;
  birthdate: Timestamp | null;
  cellphone: string;
  cellphone_country_code: string | null;
  confirmed_cellphone: boolean;
  confirmed_email: boolean;
  created_at: Generated<Timestamp | null>;
  creation_stage: SystemStage;
  currency: Generated<string>;
  day_privacy: Generated<Privacy | null>;
  email: string;
  first_name: string;
  gender: Gender | null;
  gender_other: string | null;
  gender_privacy: Generated<Privacy | null>;
  id: Generated<string>;
  introduction: string | null;
  is_customer: Generated<boolean>;
  last_name: string;
  location: Json | null;
  location_privacy: Generated<Privacy | null>;
  month_privacy: Generated<Privacy | null>;
  password: string | null;
  photo_url: string | null;
  reset_password_expiration: Timestamp | null;
  reset_password_token: string | null;
  status: UserStatus;
  type: UserType;
  updated_at: Generated<Timestamp | null>;
  year_privacy: Generated<Privacy | null>;
}

export interface ValidationCodes {
  code: string;
  created_at: Generated<Timestamp | null>;
  expire_at: Timestamp;
  id: Generated<string>;
  value: string;
}

export interface Verifications {
  created_at: Generated<Timestamp | null>;
  expires_at: Timestamp;
  id: string;
  identifier: string;
  updated_at: Generated<Timestamp | null>;
  value: string;
}

export interface DB {
  account_requests: AccountRequests;
  account_requests_approvals_control: AccountRequestsApprovalsControl;
  account_requests_status_log: AccountRequestsStatusLog;
  accounts: Accounts;
  commission_backfill_runs: CommissionBackfillRuns;
  commission_balances: CommissionBalances;
  commission_earnings: CommissionEarnings;
  commission_founder_pool: CommissionFounderPool;
  commission_payout_methods: CommissionPayoutMethods;
  commission_receipts: CommissionReceipts;
  commission_withdrawals: CommissionWithdrawals;
  founder_commission_cutoff: FounderCommissionCutoff;
  founder_commission_distribution: FounderCommissionDistribution;
  freedom_fund_cutoff: FreedomFundCutoff;
  freedom_fund_distribution: FreedomFundDistribution;
  invitation_campaign_recipients: InvitationCampaignRecipients;
  invitation_campaigns: InvitationCampaigns;
  invitation_contacts: InvitationContacts;
  invitation_email_events: InvitationEmailEvents;
  invitation_templates: InvitationTemplates;
  notifications: Notifications;
  payment_transfers: PaymentTransfers;
  payments: Payments;
  pgledger_accounts: PgledgerAccounts;
  pgledger_accounts_view: PgledgerAccountsView;
  pgledger_entries: PgledgerEntries;
  pgledger_entries_view: PgledgerEntriesView;
  pgledger_transfers: PgledgerTransfers;
  pgledger_transfers_view: PgledgerTransfersView;
  pictures: Pictures;
  referral_keys: ReferralKeys;
  refresh_tokens: RefreshTokens;
  sessions: Sessions;
  users: Users;
  validation_codes: ValidationCodes;
  verifications: Verifications;
}
